<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelItemCommande popup="popup" [model]="menuContextuelEntrees"></p-menu>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <div class="mb-4">
                <h5 class="my-1">Employés</h5>
                <span class="text-500">Vous trouverez ici la liste des utilisateurs.</span>
            </div>
            <div class="flex align-content-center justify-content-between my-2">
                <div class="flex align-items-center gap-2 flex-wrap">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="searchTerm.set($event.target.value); appliquerFiltres()"
                            [(ngModel)]="searchTerm"
                            placeholder="Rechercher un employé..." />
                    </span>
                    <button pButton pRipple icon="pi pi-plus"
                        class="p-button-success" label="Ajouter"
                        (click)="ajouter()"
                        *ngIf="estAutorise('admin_employes')"></button>
                </div>
            </div>
            <p-table #dt [value]="employesFiltres" dataKey="employeId" tableStyleClass="tableNormale"
                 [(contextMenuSelection)]="selectionEmploye"
                 [rowHover]="true" [filterDelay]="0"
                [globalFilterFields]="['nom','prenom','prenomNom','courriel']">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="prenom">
                            <div class="flex justify-content-between align-items-center">
                                Prénom
                                <p-sortIcon field="prenom"></p-sortIcon>
                                <p-columnFilter type="text" field="prenom" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nom">
                            <div class="flex justify-content-between align-items-center">
                                Nom
                                <p-sortIcon field="nom"></p-sortIcon>
                                <p-columnFilter type="text" field="nom" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="courriel">
                            <div class="flex justify-content-between align-items-center">
                                Courriel
                                <p-sortIcon field="courriel"></p-sortIcon>
                                <p-columnFilter type="text" field="courriel" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="noEmploye">
                            <div class="flex justify-content-between align-items-center">
                                No. Employé
                                <p-sortIcon field="noEmploye"></p-sortIcon>
                                <p-columnFilter type="text" field="noEmploye" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="statut">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut"></p-sortIcon>
                            </div>
                        </th>
                        <th style="min-width: 5rem; width: 5rem">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-employe>
                    <tr (contextmenu)="surMenuContextuelItem($event,employe)">
                        <td>{{employe.prenom}}</td>
                        <td>{{employe.nom}}</td>
                        <td>
                            <a *ngIf="employe.courriel" [href]="'mailto:' + employe.courriel" class="text-primary">
                                {{employe.courriel}}
                            </a>
                            <span *ngIf="!employe.courriel" class="text-500">Non spécifié</span>
                        </td>
                        <td><p-chip [label]="employe.noEmploye || 'N/A'"></p-chip></td>
                        <td>
                            <div class="flex align-items-center gap-2">
                                <span [class]="'statut ' + employe.statut.nom.replace(' ','').toLowerCase()">
                                    {{employe.statut.nom}}
                                </span> 
                                <p-tag *ngIf="employe.indInscrit" severity="success" value="Inscrit"></p-tag>
                            </div>
                        </td>
                        <td>
                            <div class="flex justify-content-end gap-2">
                                <button pButton pRipple icon="pi pi-eye" class="p-button-success boutonGrille"
                                    pTooltip="Consulter le profil"
                                    (click)="consulter(employe)"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-danger boutonGrille"
                                    pTooltip="Supprimer"
                                    (click)="supprimer(employe)"
                                    *ngIf="estAutorise('admin_employes')"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="text-center p-4">
                            <div class="flex flex-column align-items-center">
                                <i class="pi pi-users text-500 text-4xl mb-3"></i>
                                <span>Aucun employé trouvé</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>
